export { default as ParlorQuickInquiry } from "./ParlorQuickInquiry";
